export const GENDER_TYPES = { male: 'M', female: 'F' };

export const MIN_AGE = 3;

export const MAX_AGE = 99;

export const CONTENT_CATEGORIES_TYPES = {
    watchable: 'watchable',
    listenable: 'listenable',
    readable: 'readable',
    playable: 'playable'
};

export const CONTENT_TYPES = {
    video: 'video',
    audio: 'audio',
    article: 'article',
    videoSample: 'videosample',
    audioSample: 'audiosample',
    videoModel: 'videomodel',
    audioModel: 'audiomodel',
    articleModel: 'articlemodel',
    quiz: 'quiz',
    poll: 'poll',
    userCampaignMedia: 'usercampaignmedia',
    campaignVideoTrophy: 'eventvideotrophy',
    campaignEvent: 'campaignevent',
    youAndDorsaPrizes: 'youanddorsaprizes',
    comment: 'comment',
    message: 'message',
    matchVideo: 'match_video',
    series: 'series',
    season: 'season',
    episode: 'episode',
    banner: 'banner',
    ads: 'ads'
};

export const MULTIMEDIA_TYPES = {
    series: 'series',
    season: 'season',
    episode: 'episode'
};

export const UGC_TYPES = {
    trophy: 'trophy'
};

export const BADGE_STATUS_TYPES = {
    inProgress: 'in_progress',
    pendingReward: 'pending_reward',
    achieved: 'achieved'
};

export const QUESTIONS_PAGE_STATE = {
    notStarted: 'Not Started',
    start: 'start',
    answer: 'answer',
    quit: 'quit',
    hint: 'hint',
    finished: 'finished'
};

export const MATCH_HINTS_TYPES = {
    findAnswer: 'find_answer',
    secondChance: 'second_chance',
    secondChanceUsed: 'second_chance_used',
    optionElimination: 'option_elimination'
};

export const QUIZ_TYPES = {
    simple: 'Simple',
    video: 'Video',
    image: 'Image',
    audio: 'Audio',
    article: 'Article'
};

export const MATCH_TYPES = {
    normal: 0,
    sequential: 1
};

export const MATCH_PAGE_SECTION_TYPES = {
    tile: 'Tile',
    list: 'List',
    container6: 'Container 6'
};

export const MATCH_PAGE_CONTENT_TYPES = {
    match: 'Match',
    banner: 'Banner',
    videoTrophy: 'Campaign Video Trophy',
    campaignVideo: 'Campaign Video'
};

export const MY_VIDEO_STATUSES = {
    pending: 'PND',
    rejected: 'REJ',
    accepted: 'ACC'
};

export const MY_COMMENT_STATUSES = {
    pending: 'PND',
    rejected: 'REJ',
    accepted: 'ACC'
};

export const HOBE_HUNGRINESS_THRESHOLDS = {
    hungrinessThreshold1: 20,
    hungrinessThreshold2: 40,
    hungrinessThreshold3: 60
};

export const HOBE_ENERGY_GAUGE_THRESHOLDS = {
    energyGaugeThreshold1: 30,
    energyGaugeThreshold2: 70
};

export const HOBE_STATES = {
    sick: 'sick',
    veryHungry: 'veryHungry',
    hungry: 'hungry',
    full: 'full'
};

export const HOBE_EATING_PROXIMITY_VALUES = {
    eatingStateProximityOffset: 20,
    readyToEatStateProximityOffset: 60
};

export const LOG_COLLECTOR_USER_AGENT_DATA = {
    user_agent: 'web',
    version: process.env.NEXT_PUBLIC_APP_VERSION
};
